import { render, staticRenderFns } from "./RegisterPracticeAndBehaviorSlidebar.vue?vue&type=template&id=9c07ee96"
import script from "./RegisterPracticeAndBehaviorSlidebar.vue?vue&type=script&lang=js"
export * from "./RegisterPracticeAndBehaviorSlidebar.vue?vue&type=script&lang=js"
import style0 from "./RegisterPracticeAndBehaviorSlidebar.vue?vue&type=style&index=0&id=9c07ee96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports